module.exports = __webpack_public_path__ + "assets/5d590dd66884af88095d4898a9a6d8ca.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/BgmFg.mp3
 ** module id = 489
 ** module chunks = 0
 **/